import { ChainId } from '@uniswap/sdk'
import React, { useEffect, useState } from 'react'
import { Text } from 'rebass'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { darken } from 'polished'
import { useTranslation } from 'react-i18next'
import { isMobile, isAndroid, isIOS } from 'react-device-detect'
// import { useDispatch } from 'react-redux'
// import { AppDispatch } from '../../state/index'

// @ts-ignore
import transakSDK from '@transak/transak-sdk'
//import { useTransactionAdder } from '../../state/transactions/hooks'

import styled from 'styled-components'
// import { addPopup } from '../../state/application/actions'

// import Logo from '../../assets/images/QuickSwap_logo.png'
// import LogoMobile from '../../assets/images/logo_circle.png'
//import LogoDark from '../../assets/svg/logo_white.svg'
import { useActiveWeb3React } from '../../hooks'
//import { useDarkModeManager } from '../../state/user/hooks'
import { useETHBalances } from '../../state/wallet/hooks'
// import { CardNoise } from '../earn/styled'
// import { CountUp } from 'use-count-up'
// import { TYPE } from '../../theme'

import { YellowCard } from '../Card'
// import Settings from '../Settings'
//import Menu from '../Menu'

import Row, { RowFixed } from '../Row'
import Web3Status from '../Web3Status'
import ClaimModal from '../claim/ClaimModal'
// import { useToggleSelfClaimModal, useShowClaimPopup } from '../../state/application/hooks'
// import { useUserHasAvailableClaim } from '../../state/claim/hooks'
// import { useUserHasSubmittedClaim } from '../../state/transactions/hooks'
// import { Dots } from '../swap/styleds'
import Modal from '../Modal'
import UniBalanceContent from './UniBalanceContent'
// import usePrevious from '../../hooks/usePrevious'
import LogoImg from '../../assets/images/logo.png'

const HeaderFrame = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  padding: 1rem 0rem;
  z-index: 2;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: 1fr;
    padding: 1rem 0rem;
    width: calc(100%);
    position: relative;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        padding: 1rem 0rem;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    width: 100%;
    max-width: 960px;
    padding: 1rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 99;
    height: 72px;
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.bg1};
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
   flex-direction: row-reverse;
    align-items: center;
  `};
`

// const HeaderElementWrap = styled.div`
//   display: flex;
//   align-items: center;
// `

const HeaderRow = styled(RowFixed)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
   width: 100%;
  `};
`

const HeaderLinks = styled(Row)`
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
  padding: 1rem 0 1rem 1rem;
  justify-content: flex-end;
`};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, active }) => (!active ? theme.bg1 : theme.bg3)};
  border-radius: 12px;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;

  :focus {
    border: 1px solid blue;
  }
  /* :hover {
    background-color: ${({ theme, active }) => (!active ? theme.bg2 : theme.bg4)};
  } */
`

// const UNIAmount = styled(AccountElement)`
//   color: white;
//   padding: 4px 8px;
//   height: 36px;
//   font-weight: 500;
//   background-color: ${({ theme }) => theme.bg3};
//   background: radial-gradient(174.47% 188.91% at 1.84% 0%, #0a1647 0%, #2172e5 100%), #edeef2;
// `

// const UNIWrapper = styled.span`
//   width: fit-content;
//   position: relative;
//   cursor: pointer;

//   :hover {
//     opacity: 0.8;
//   }

//   :active {
//     opacity: 0.9;
//   }
// `

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetworkCard = styled(YellowCard)`
  border-radius: 12px;
  padding: 8px 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  `};
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

const UniIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`

const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({
  activeClassName
})`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }
`

// const StyledExternalLink = styled(ExternalLink).attrs({
//   activeClassName
// })<{ isActive?: boolean }>`
//   ${({ theme }) => theme.flexRowNoWrap}
//   align-items: left;
//   border-radius: 3rem;
//   outline: none;
//   cursor: pointer;
//   text-decoration: none;
//   color: ${({ theme }) => theme.text2};
//   font-size: 1rem;
//   width: fit-content;
//   margin: 0 12px;
//   font-weight: 500;

//   &.${activeClassName} {
//     border-radius: 12px;
//     font-weight: 600;
//     color: ${({ theme }) => theme.text1};
//   }

//   :hover,
//   :focus {
//     color: ${({ theme }) => darken(0.1, theme.text1)};
//   }
// `

// const StyledLinkStyledButton = styled(LinkStyledButton).attrs({
//   activeClassName
// })<{ isActive?: boolean }>`
//   ${({ theme }) => theme.flexRowNoWrap}
//   align-items: left;
//   border-radius: 3rem;
//   outline: none;
//   cursor: pointer;
//   text-decoration: none;
//   color: ${({ theme }) => theme.text2};
//   font-size: 1rem;
//   width: fit-content;
//   margin: 0 12px;
//   font-weight: 500;
//   &.${activeClassName} {
//     border-radius: 12px;
//     font-weight: 600;
//     color: ${({ theme }) => theme.text1};
//   }
//   :hover,
//   :focus {
//     color: ${({ theme }) => darken(0.1, theme.text1)};
//   }
// `

// const NETWORK_LABELS: { [chainId in ChainId]: string | undefined } = {
//     [ChainId.MUMBAI]: 'Mumbai',
//     [ChainId.MATIC]: 'Polygon'
// }

export default function Header() {
  const location = useLocation()

  // const dispatch = useDispatch<AppDispatch>()
  // const initiateTransak = (account: any) => {
  //   let transak = new transakSDK({
  //     apiKey: '258960cf-1e17-4419-bf7f-77443282f5da', // Your API Key
  //     environment: 'PRODUCTION', // STAGING/PRODUCTION
  //     defaultCryptoCurrency: 'MATIC',
  //     disablePaymentMethods: 'credit_debit_card',
  //     walletAddress: account, // Your customer's wallet address
  //     themeColor: '2891f9', // App theme color
  //     redirectURL: 'window.location.origin',
  //     hostURL: window.location.origin,
  //     widgetHeight: mobile ? '450px' : '600px',
  //     widgetWidth: mobile ? '360px' : '450px',
  //     networks: 'matic'
  //   })

  //   transak.init()

  //   // To get all the events
  //   transak.on(transak.TRANSAK_ORDER_FAILED, (data: any) => {
  //     dispatch(addPopup({ key: 'abc', content: { txn: { hash: '', summary: 'Buy order failed', success: false } } }))
  //     console.log(data)
  //   })

  //   // This will trigger when the user marks payment is made.
  //   transak.on(transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData: any) => {
  //     dispatch(
  //       addPopup({
  //         key: 'abc',
  //         content: {
  //           txn: {
  //             hash: '',
  //             summary:
  //               'Buy ' +
  //               orderData.status.cryptoAmount +
  //               ' ' +
  //               orderData.status.cryptocurrency +
  //               ' for ' +
  //               orderData.status.fiatAmount +
  //               ' ' +
  //               orderData.status.fiatCurrency,
  //             success: true
  //           }
  //         }
  //       })
  //     )
  //     console.log(orderData)
  //     transak.close()
  //   })
  // }

  const { account, chainId } = useActiveWeb3React()

  /**const ClaimMatic = async(address: string) => {
    const response = await fetch("https://api.easyfi.network/api/claimAllowance?ureq=1608049206867", {
      headers: {
        'Content-Type': 'application/json',
        'address': address
      }
      
    });
    var r = await response.json();
    if(r.success) {
      toast.info("Claim Successful. Please refresh page in couple of minutes");
    }
    else {
      toast.dark(r.message);
    }
    
}*/

  const { t } = useTranslation()

  const mobile = isMobile || isAndroid || isIOS

  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  //const [isDark] = useDarkModeManager()

  // const toggleClaimModal = useToggleSelfClaimModal()

  // const availableClaim: boolean = useUserHasAvailableClaim(account)

  // const { claimTxn } = useUserHasSubmittedClaim(account ?? undefined)

  // const aggregateBalance: TokenAmount | undefined = useAggregateUniBalance()

  const [showUniBalanceModal, setShowUniBalanceModal] = useState(false)
  // const showClaimPopup = useShowClaimPopup()

  // const countUpValue = aggregateBalance?.toFixed(0) ?? '0'
  // const countUpValuePrevious = usePrevious(countUpValue) ?? '0'
  return (
    // <HeaderFrame>
    <>
      <ClaimModal />
      <Modal isOpen={showUniBalanceModal} onDismiss={() => setShowUniBalanceModal(false)}>
        <UniBalanceContent setShowUniBalanceModal={setShowUniBalanceModal} />
      </Modal>
      <div className="w-full">
        <nav className="p-5 bg-[#1b1b1b] text-[#EAD5BA] text-2xl w-full px-[1rem] pt-[1rem]">
          <div className="flex flex-wrap items-center w-full justify-evenly md:flex-nowrap">
            <div className="flex items-center md:pl-[20vw] order-1 w-1/3 justify-evenly md:justify-start md:w-1/3 text-sm">
              <Link to='/swap'>
                {/*  */}
                <div className={`${location.pathname == '/swap' && "text-[#4c8be9] underline underline-offset-[6.7808px]"} cursor-pointer pb-[5.7808px] pr-2`}>Swap</div>
              </Link>
              <div className="md:w-[3.625rem]"></div>
              <Link to='/pools'>
                <div className={`${location.pathname == '/pools' && "text-[#4c8be9] underline underline-offset-[6.7808px]"} cursor-pointer pb-[5.7808px] pr-2`}>Pools</div>
              </Link>
              <div className="md:w-[3.625rem]"></div>
              <Link to='/comingGovernance'>
                <div className={`${location.pathname == '/comingGovernance' && "text-[#4c8be9] underline underline-offset-[6.7808px]"} cursor-pointer pb-[5.7808px] pr-2`}>Governance</div>
              </Link>
              <Link to='/comingStaking'>
                <div className={`${location.pathname == '/comingStaking' && "text-[#4c8be9] underline underline-offset-[6.7808px]"} cursor-pointer pb-[5.7808px] pr-2`}>Staking</div>
              </Link>
              
            </div>
            <div className="w-full order-0 md:order-1 md:w-fit pb-[30px] md:pb-0">
              {/* <svg style={{ width: '100px', height: '60px' }} className="mx-auto" viewBox="0 0 161 93" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M27.9401 1.56927C37.0701 1.56927 42.94 7.77926 41.61 17.3693L33.7201 75.9993C33.2505 80.3961 31.1494 84.4571 27.8318 87.3804C24.5141 90.3037 20.221 91.8768 15.8 91.7892H0L12.14 1.5293L27.9401 1.56927ZM12.8 80.5693H17.3201C18.565 80.5311 19.7576 80.0597 20.6923 79.2364C21.6269 78.4131 22.2451 77.2895 22.4401 76.0593L30.3201 17.3893C30.4162 16.8274 30.3868 16.2512 30.2338 15.702C30.0808 15.1529 29.8079 14.6445 29.4351 14.2133C29.0622 13.7821 28.5985 13.4388 28.0771 13.2082C27.5558 12.9775 26.9899 12.8652 26.42 12.8793H21.9L12.8 80.5693Z" fill="#EAD5BA"></path>
                                <path d="M81.5386 16.2388L76.0786 56.8588C75.609 61.2556 73.5079 65.3166 70.1903 68.2399C66.8726 71.1632 62.5795 72.7364 58.1586 72.6488C49.0186 72.6488 43.1585 66.4488 44.4885 56.8588L49.9486 16.2388C50.4182 11.8419 52.5191 7.78096 55.8368 4.85766C59.1544 1.93435 63.4476 0.361214 67.8685 0.448781C77.0485 0.448781 82.8686 6.64876 81.5386 16.2388ZM61.2886 16.2388L55.8286 56.8588C55.7341 57.4212 55.765 57.9977 55.9193 58.5467C56.0736 59.0958 56.3474 59.604 56.7211 60.035C57.0947 60.4659 57.5589 60.809 58.0806 61.0395C58.6022 61.2701 59.1683 61.3825 59.7385 61.3688C60.9835 61.3306 62.1762 60.8592 63.1108 60.0359C64.0455 59.2126 64.6635 58.089 64.8585 56.8588L70.3186 16.2388C70.4131 15.6763 70.3821 15.0999 70.2278 14.5508C70.0735 14.0017 69.7998 13.4935 69.4261 13.0626C69.0525 12.6316 68.5883 12.2886 68.0666 12.058C67.545 11.8274 66.9787 11.715 66.4086 11.7287C65.1601 11.7624 63.9628 12.2317 63.024 13.0554C62.0853 13.8791 61.4642 15.0053 61.2685 16.2388H61.2886Z" fill="#EAD5BA"></path>
                                <path d="M121.409 16.2388L113.219 77.1588C112.747 81.5556 110.646 85.6163 107.329 88.5408C104.012 91.4653 99.7201 93.0415 95.2988 92.9588C86.1588 92.9588 80.2987 86.7488 81.6187 77.1588L89.8088 16.2388C90.2808 11.8411 92.3838 7.78005 95.7031 4.85694C99.0224 1.93383 103.317 0.361007 107.739 0.448799C116.869 0.448799 122.699 6.64878 121.409 16.2388ZM101.099 16.2388L92.9088 77.1588C92.811 77.7214 92.8392 78.2987 92.9914 78.8491C93.1437 79.3995 93.4162 79.9093 93.7893 80.3416C94.1623 80.774 94.6266 81.1182 95.1488 81.3494C95.6709 81.5807 96.2379 81.6931 96.8088 81.6788C98.0558 81.6421 99.2506 81.17 100.186 80.3443C101.121 79.5187 101.738 78.3916 101.929 77.1588L110.119 16.2388C110.215 15.6769 110.185 15.1007 110.032 14.5515C109.879 14.0024 109.607 13.494 109.234 13.0628C108.861 12.6316 108.397 12.2883 107.876 12.0577C107.355 11.827 106.789 11.7147 106.219 11.7288C104.973 11.765 103.78 12.2358 102.845 13.0594C101.91 13.883 101.292 15.0078 101.099 16.2388Z" fill="#EAD5BA"></path>
                                <path d="M160.44 16.2382L156.95 42.2382H146.8L148.24 31.5182H137.18L135.74 42.2382H125.59L129.07 16.2382C129.624 11.9206 131.737 7.95445 135.012 5.08669C138.287 2.21893 142.497 0.647435 146.85 0.668171C155.99 0.668171 161.64 7.32818 160.44 16.2382ZM139.22 16.3482L138.4 22.4482H149.45L150.27 16.3482C150.359 15.6728 150.3 14.9863 150.096 14.3361C149.893 13.686 149.551 13.088 149.093 12.5836C148.635 12.0792 148.073 11.6805 147.446 11.4154C146.818 11.1502 146.141 11.0249 145.46 11.0482C143.969 11.0785 142.534 11.6224 141.397 12.5879C140.26 13.5534 139.491 14.8816 139.22 16.3482Z" fill="#EAD5BA"></path>
                                <path d="M145.36 51.209C152.58 51.209 155.6 56.409 154.8 62.389C154.528 65.2082 153.28 67.8438 151.271 69.8411C149.263 71.8383 146.621 73.0719 143.8 73.329L143.62 74.679C148.07 75.129 152.76 77.159 151.84 84.049L150.84 91.829H140.69L141.57 85.2889C142.11 81.2289 139.99 78.519 136.27 78.519H131.19L129.4 91.829H119.25L124.71 51.209H145.36ZM132.36 69.939H139.47C140.646 69.9229 141.776 69.4799 142.65 68.6925C143.524 67.9051 144.082 66.827 144.22 65.6589C144.54 63.2889 143.22 61.369 140.62 61.369H133.54L132.36 69.939Z" fill="#EAD5BA"></path>
                                <path d="M72.88 81H41.29L39.8301 91.83H71.42L72.88 81Z" fill="#A2FD1C"></path>
                            </svg> */}
              <img src="/main-logo.jpg" alt="" className="mx-auto" style={{ width: '100px', height: '100px', borderRadius:'50%' }} />

            </div>
            <div className="flex items-center order-1 justify-evenly w-2/3 md:pr-[10vw] md:w-1/3">
              <div className="cursor-pointer hide-tap">
                {/* <div className="relative z-[10] mt-1 bg-[#333333] rounded-4xl cursor-pointer border-[.1rem] border-[#545454]" style={{ boxShadow: 'rgba(0, 0, 0, 0.25) 0px 0.8rem 2.4rem', borderRadius: "100px" }}>
                                        <button className="relative w-full flex mr-1 py-1 pr-6 text-left shadow-md cursor-pointer focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm" id="headlessui-listbox-button-:r2b:" type="button" aria-haspopup="true" aria-expanded="false">
                                        </button>
                                    </div> */}
              </div>
              <div className="md:w-[3.625rem]"></div>
              <div className="z-10 hide-tap ml-2">
                {/* <div id="wallets_select_button" className="wallets_select_button relative mt-1 rounded-4xl border-[.1rem] border-[#545454] bg-white" style={{ boxShadow: 'rgba(0, 0, 0, 0.25) 0px 0.8rem 2.4rem', borderRadius: "100px" }}>
                                    <button className="relative flex w-full py-1 pl-3 pr-6 text-left rounded-lg shadow-md wallets_select_button sm:text-sm" id="headlessui-listbox-button-:r5:" type="button" aria-haspopup="true" aria-expanded="false">
                                        <div id="connect-wallet" className="!bg-dark-900 bg-gradient-to-r from-pink/80 hover:from-pink to-purple/80 hover:to-purple h-[25px] !border-none items-center whitespace-nowrap justify-center flex text-black font-medium text-[14px] cursor-pointer">
                                            <span>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.5 14.5H16.5M5 8.5H19V18.5H5V8.5Z" stroke="black" stroke-width="1.5"></path>
                                                    <path d="M5 8V6H15V8" stroke="black" stroke-width="1.5"></path>
                                                </svg>
                                            </span>

                                            Connect wallet
                                        </div>
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                            <svg className="" width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 4.5L16.5 12L9 19.5" stroke="#1f1f1f" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path>
                                            </svg>
                                        </span>
                                    </button>
                                </div> */}
                <Web3Status />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
    // </HeaderFrame>
  )
}
